export default "__VITE_ASSET__BHUQLTOD__"